import type { Theme } from '../../contract.js';
import { neonLight, neonDark } from './variants.js';

/**
 * Neon family — synthwave pink accent, brand-green charging.
 * Promoted from `skin_neon` overlay to a first-class family
 * during the Driver Themes ticket. Routes the ChargingAnimation
 * to the standalone synthwave shader (sky gradient, rising sun
 * with stripe carve-outs, mountain silhouettes, wireframe
 * foreground).
 *
 * Satellite Streets basemap for both modes — the neon palette
 * reads well over the satellite imagery without needing a
 * dedicated cartographic basemap.
 */
export const neonTheme: Theme = {
  id: 'neon',
  name: 'Neon',
  description: 'Synthwave pink accent over brand-green energy.',
  swatches: ['#0A0A0F', '#FF2EC8', '#21c163'],
  variants: { light: neonLight, dark: neonDark },
  unlockedByDefault: true,
  costPoints: 0,
  mapStyle: {
    light: 'mapbox://styles/mapbox/satellite-streets-v12',
    dark: 'mapbox://styles/mapbox/satellite-streets-v12',
  },
  chargingAnimation: 'shader',
  shaderKind: 'neon',
};
